import React, { useState } from 'react';

const DataExtraction = () => {
  const [extractionTypes, setExtractionTypes] = useState({
    orders: true,
    appointments: false,
    inquiries: false,
    complaints: false,
  });

  const [orderFields, setOrderFields] = useState({
    product: true,
    quantity: true,
    price: true,
    delivery: true,
    payment: true,
  });

  const handleExtractionTypeChange = (type) => {
    setExtractionTypes(prev => ({
      ...prev,
      [type]: !prev[type]
    }));
  };

  const handleOrderFieldChange = (field) => {
    setOrderFields(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Configura la Extracción de Datos
          </h2>
          <p className="mt-4 text-lg text-gray-500">
            Selecciona qué información quieres extraer de tus mensajes de WhatsApp
          </p>
        </div>

        <div className="mt-12 bg-white shadow sm:rounded-lg p-6">
          <div className="space-y-8">
            <div>
              <h3 className="text-lg font-medium text-gray-900">Tipos de Mensajes</h3>
              <p className="mt-1 text-sm text-gray-500">
                Selecciona los tipos de mensajes que quieres procesar
              </p>
              <div className="mt-4 space-y-4">
                {Object.entries(extractionTypes).map(([type, enabled]) => (
                  <div key={type} className="flex items-center">
                    <input
                      id={type}
                      name={type}
                      type="checkbox"
                      checked={enabled}
                      onChange={() => handleExtractionTypeChange(type)}
                      className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
                    />
                    <label htmlFor={type} className="ml-3 block text-sm font-medium text-gray-700">
                      {type === 'orders' && 'Pedidos'}
                      {type === 'appointments' && 'Citas'}
                      {type === 'inquiries' && 'Consultas'}
                      {type === 'complaints' && 'Quejas'}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            {extractionTypes.orders && (
              <div>
                <h3 className="text-lg font-medium text-gray-900">Campos de Pedidos</h3>
                <p className="mt-1 text-sm text-gray-500">
                  Selecciona qué información quieres extraer de los pedidos
                </p>
                <div className="mt-4 space-y-4">
                  {Object.entries(orderFields).map(([field, enabled]) => (
                    <div key={field} className="flex items-center">
                      <input
                        id={field}
                        name={field}
                        type="checkbox"
                        checked={enabled}
                        onChange={() => handleOrderFieldChange(field)}
                        className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
                      />
                      <label htmlFor={field} className="ml-3 block text-sm font-medium text-gray-700">
                        {field === 'product' && 'Producto'}
                        {field === 'quantity' && 'Cantidad'}
                        {field === 'price' && 'Precio'}
                        {field === 'delivery' && 'Entrega'}
                        {field === 'payment' && 'Pago'}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="pt-5">
              <div className="flex justify-end">
                <button
                  type="button"
                  className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                >
                  Guardar Configuración
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataExtraction; 